<template>
  <a-modal
    class="contact-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    :title="title"
    :confirm-loading="btnIsLoading"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #user_realname>
        <a-input
          v-decorator="['user_realname',{rules: [
            { required: true, message: '请输入真实姓名' },
          ],}]"
          placeholder="请输入真实姓名"
        />
      </template>
      <template #sex>
        <a-radio-group
          v-decorator="['sex',{rules: [
            { required: true, message: '请选择性别' },
          ],}]"
        >
          <a-radio :value="1">
            男
          </a-radio>
          <a-radio :value="2">
            女
          </a-radio>
        </a-radio-group>
      </template>
      <template #user_pass>
        <a-input
          v-decorator="['user_pass',{rules: [
            { required: false, message: '请输入密码' },
          ],}]"
          placeholder=" 默认密码 66666666 ， 若修改，则为修改后的新密码"
        />
      </template>
      <template #promoters>
        <a-select
          v-decorator="['promoters',{rules: [
            { required: true, message: '请选择推广员' },
          ]}]"
          placeholder="请选择推广员"
          mode="multiple"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="item in promoterData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.user_realname }}
          </a-select-option>
        </a-select>
      </template>
      <template #provinceCity>
        <province-city
          v-decorator="[
            'provinceCity',
          ]"
        />
      </template>
      <template #address>
        <a-input
          v-decorator="['address',{rules: [
            { required: false, message: '请输入详细地址' },
          ],}]"
          placeholder="请输入详细地址"
        />
      </template>
      <template #mobile>
        <a-input
          v-decorator="[
            'mobile',
            {
              rules: [
                { required: true, message: '请输入手机号码' },
                {
                  pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                  message: '请输入正确的手机号码',
                },
              ],
            },
          ]"
          placeholder="请输入手机号码"
        />
      </template>
      <template #hospital_id>
        <a-select
          v-decorator="[
            'hospital_id',
            { rules: [{ required: true, message: '请选择医院' }] }
          ]"
          show-search
          placeholder="请选择医院"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="item in hospitalsData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </template>
      <template #speciality>
        <a-input
          v-decorator="['speciality',{rules: [
            { required: false, message: '请输入擅长' },
          ],}]"
          placeholder="请输入擅长"
        />
      </template>
      <template #department_id>
        <a-tree-select
          v-decorator="['department_id',{rules: [
            { required: true, message: '请选择科室' },
          ],}]"
          :tree-data="sectionData"
          placeholder="请选择科室"
        />
      </template>
      <template #professional_id>
        <a-select
          v-decorator="['professional_id',{rules: [
            { required: true, message: '请选择职称' },
          ],}]"
          placeholder="请选择职称"
        >
          <a-select-option
            v-for="item in rankData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </template>
    </basic-form>
  </a-modal>
</template>
<script>
import {
  formData,
} from '../data/index';
import ProvinceCity from './../components/ProvinceCity';
export default{
  components: {ProvinceCity},
  props: ['title', 'visible', 'btnIsLoading'],
  data(){
    return{
      seach: false,
      seach_hospital_list: [],
      keyword: '',
      formData,
      promoterData: [],
      sectionData: [],
      hospitalsData: [],
      rankData: [],
    };
  },
  mounted(){
    // 获取推广员
    this.getPromoterData();
    // 获取科室
    this.getSectionData();
    // 获取职称数据
    this.getRankData();
    // 获取医院数据
    this.getHospitalList();
  },
  methods: {
    // 下拉筛选
    filterOption(inputValue, option){
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
      );
    },
    // 获取医院列表
    async getHospitalList() {
      let result = await this.$http.post('/system/hospital_list', {
        page: 1,
        pageSize: 30,
      });
      this.hospitalsData = result.data.data.data_list;
    },
    // 获取推广员
    async getPromoterData() {
      let result = await this.$http.post('/promoter/adminGetList', {page: 1, pageSize: 1000});
      if (result.data.status === 1) {
        this.promoterData = result.data.data.data_list;
      }
    },
    // 科室处理
    dealData(data) {
      data.forEach((item) => {
        item.title=item.name;
        item.key=item.id;
        item.value=String(item.id);
        item.selectable=false;
        item.children=item.child_list;
        item.child_list.forEach((child)=>{
          child.title=child.name;
          child.key=child.id;
          child.value=String(child.id);
        });

      });
      return data;
    },
    // 获取职称数据
    async getRankData() {
      let result = await this.$http.post('/system/getProfessionalList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.rankData =[...this.rankData, ...data];
      }
    },
    // 获取科室数据
    async getSectionData() {
      let result = await this.$http.post('/system/getDepartmentList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.sectionData = [...this.sectionData, ...this.dealData(JSON.parse(JSON.stringify(data)))];
      }
    },
    // 自定义省市校验
    checkProvinceCity(rule, value, callback) {
      const error = [];
      if (!value || !value.province) {
        error.push('省份');
      }
      if (!value || !value.city) {
        error.push('城市');
      }
      if (error.length === 0) {
        callback();
      }
      callback(`请选择${error.join('和')}`);
    },
  },
};
</script>
<style lang="scss" scoped>
  .seachlist {
  max-height: 240px;
  overflow: scroll;
  overflow-x: hidden;
  p {
    line-height: 40px;
    height: 40px;
  }
}
</style>